(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bloss-regalo"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bloss-gift'))customElements.define('bloss-gift',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.media=matchMedia('(prefers-reduced-motion: reduce)');this.manual=false;this.value=0;this.frame=0;const options={signal:this.abort.signal};this.button=this.querySelector('.bloss-gift__button');this.scene=this.querySelector('.bloss-gift__scene');this.classList.add('is-ready');this.update=(event)=>{if(event?.type==='scroll'){this.manual=false;cancelAnimationFrame(this.frame);}if(this.manual)return;if(this.media.matches||this.dataset.animate!=='true')return this.paint(1);const rect=this.getBoundingClientRect(),r=this.scene.getBoundingClientRect();this.paint(this.clientWidth>749?(innerHeight*.45-rect.top)/Math.max(320,innerHeight*.55):(innerHeight*.85-r.top)/(innerHeight*.45));};document.addEventListener('scroll',this.update,{...options,passive:true,capture:true});window.addEventListener('resize',this.update,options);this.media.addEventListener('change',this.update,options);this.button.addEventListener('click',()=>{this.manual=true;const start=performance.now(),from=this.value,to=from>.8?0:1;cancelAnimationFrame(this.frame);if(this.media.matches)return this.paint(to);const animate=t=>{const progress=Math.min((t-start)/650,1);this.paint(from+(to-from)*(1-Math.pow(1-progress,3)));if(progress<1)this.frame=requestAnimationFrame(animate);};this.frame=requestAnimationFrame(animate);},options);this.update();}paint(value){this.value=Math.max(0,Math.min(1,value));this.style.setProperty('--bloss-open',this.value);this.button.setAttribute('aria-expanded',String(this.value>.8));this.button.textContent=this.value>.8?'Volver a ver la caja ↗':'Descubre tu sorpresa ↗';}disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.frame);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
